/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import './Login.css';
import React from 'react';
import FormInput from './FormInput';
import { withParamsAndNavigate } from './WithParamsAndNavigate';
import { qreq } from '../shared/qrequest';
import BaseCom from './BaseCom';
import Alert from './Alert';
import { Link } from 'react-router-dom';
import L from './Lang';
import Auth from '../shared/Auth';
import LangIcon from './LangIcon';

class Login extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            credentials: {},
            submitting: false
        };

        this.submit = this.submit.bind(this);
        this.submitMFA = this.submitMFA.bind(this);
        this.setUser = this.setUser.bind(this);
    }

    async componentDidMount() {
        await this.getMainOrg((err) => {
            if (err != 'Failed to get main org.')
                this.setState({ instanceError: err });
        });
        await this.getSystemSettings();
        await this.getSettings();
    }

    setUser() {
        this.props.setUser?.();
    }

    change = () => {
        this.setState({ credentials: { ...this.state.credentials } });
    }

    submit(e) {
        e.preventDefault();
        this.setState({ submitting: true });

        qreq.post('/api/auth/login', this.state.credentials, j => {
            if (j.errorCode === 101)
                this.setState({ mfa: true, medium: j.errorMessage, credentials: { ...this.state.credentials, code: '' } });
            else if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.item) {
                this.setState({ loginSuccess: true });
                this.continue();
            }

            this.setState({ submitting: false });
        }, e => {
            this.alert('An unknown error occurred. Login service might be down.');
            this.setState({ submitting: false });
        });
    }

    submitMFA(e) {
        e.preventDefault();
        this.setState({ submitting: true });

        qreq.post('/api/auth/mfa', { ...this.state.credentials }, j => {
            if (j.errorCode) {
                this.alert(j.errorMessage);
                this.setState({ submitting: false });
            }
            else {
                this.setState({ loginSuccess: true });
                this.continue();
            }
        }, e => {
            this.alert('An unknown error occurred. Login service might be down.');
            this.setState({ submitting: false });
        });
    }

    continue = () => {
        if (this.props.params.follow)
            window.location.replace(atob(this.props.params.follow));
        else
            window.location.replace(Auth.followPath);
    };

    renderLogo(mobile = false) {
        return (
            <img
                src={this.getMainOrgLogoURL(mobile)}
                alt=""
                className="img-fluid login-brand-logo mx-auto d-block"
            />
        );
    }

    renderSuccess() {
        return (
            <div className="login-card text-center">
                <div className="d-md-none mb-4">{this.renderLogo()}</div>
                <div className="login-status-icon success">✓</div>
                <h2><L>Login Successful</L></h2>
                <p className="text-muted mb-0"><L>Loading the portal...please wait...</L></p>
            </div>
        );
    }

    renderMFA() {
        return (
            <div className="login-card">
                <div className="d-md-none mb-4">{this.renderLogo()}</div>
                <div className="login-card-header text-center">
                    <div className="login-status-icon">#</div>
                    <h2><L>Multi-Factor Authentication</L></h2>
                    <p>A code has been sent to your {this.state.medium}. Please enter it below.</p>
                </div>

                <form onSubmit={this.submitMFA}>
                    <FormInput model={this.state.credentials} name="code" label="Code" type="text" placeholder="XXXXXX" required={true} autoComplete={false} />

                    <div className="d-grid mt-4">
                        <button type="submit" className="btn btn-primary btn-lg login-submit" disabled={this.state.submitting}>
                            {this.state.submitting ? <L>Submitting...</L> : <L>Submit</L>}
                        </button>
                    </div>

                    <div className="text-center mt-3">
                        <button
                            type="button"
                            className="btn btn-link login-link"
                            onClick={() => this.setState({ mfa: false, medium: null, credentials: { username: this.state.credentials.username } })}
                        >
                            <L>Cancel and Go Back</L>
                        </button>
                    </div>
                </form>
            </div>
        );
    }

    renderLoginForm() {
        return (
            <div className="login-card">
                <div className="d-md-none mb-4">{this.renderLogo()}</div>


                <div className="login-card-header text-center">
                    <span className="login-eyebrow"><L>Welcome Back</L></span>
                    <h2><L>Login</L></h2>
                    <p><L>Access</L> <b>{this.state.SETTINGS?.title}</b></p>
                </div>

                <form onSubmit={this.submit}>
                    <FormInput model={this.state.credentials} name="username" label="Email Address" type="text" required={true} labelAsPlaceholder={true} autoComplete="username" onChange={this.change} />
                    <FormInput model={this.state.credentials} name="password" label="Password" type="password" required={true} labelAsPlaceholder={true} autoComplete="current-password" onChange={this.change} />

                    <div className="login-options">
                        <FormInput model={this.state.credentials} name="isPersistent" label="Remember Me?" type="switch" onChange={this.change} />
                        <Link to="/forgot-password" className="login-link"><L>Forgot Password?</L></Link>
                    </div>

                    <div className="d-grid mt-4">
                        <button type="submit" className="btn btn-primary btn-lg login-submit" disabled={this.state.submitting}>
                            {this.state.submitting ? <L>Logging in...</L> : <L>Login</L>}
                        </button>
                    </div>
                </form>

                {this.state.error ? <div className="alert alert-danger mt-3 mb-0">{this.state.error}</div> : null}

            </div>
        );
    }

    render() {
        return (
            <main className="c-login login-page">
                <div className="login-shell">


                    <section className="login-panel login-panel-form">
                        <div className="login-content">
                            {this.state.instanceError && <Alert type="danger">{this.state.instanceError}</Alert>}
                            {!this.state.instanceError && (this.state.loginSuccess ? this.renderSuccess() : this.state.mfa ? this.renderMFA() : this.renderLoginForm())}
                        </div>
                    </section>

                    <section className="login-panel login-panel-brand d-none d-md-flex" style={{ backgroundImage: 'url(\'/img/login-right-bg.jpg\')' }}>
                        <div className="login-brand-overlay"></div>
                        <div className="login-brand-content">
                            <div className="login-brand-card">
                                {this.renderLogo(true)}
                                <div className="login-brand-text text-center">
                                    <span>{this.state.SETTINGS?.title}</span>
                                    <h1><L>Secure Portal Access</L></h1>
                                    <p><L>Sign in to continue to your workspace.</L></p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="login-lang">
                        <LangIcon />
                    </div>

                </div>
            </main>
        );
    }
}

export default withParamsAndNavigate(Login);
